import { selectUpcomingMatchesByTime } from "selectors/Match";
import { getTimeMs } from "TimeHelper";
import { UpcomingMatches } from "./UpcomingMatches";
import { useAppSelector } from "app/hooks";

interface Props {
  threshold: number;
  showTrackScores: boolean;
}

export const UpcomingMatchesThreshold = ({
  threshold,
  showTrackScores,
}: Props) => {
  const upcomingMatches = useAppSelector((state) =>
    selectUpcomingMatchesByTime(state, getTimeMs() + threshold)
  );

  return (
    <UpcomingMatches
      matches={upcomingMatches}
      showTrackScores={showTrackScores}
    />
  );
};
